export default function characterCounter() {
    const counters = document.querySelectorAll('[data-role="character-counter"]');
    counters.forEach((counter) => {
        const counterDisplayTarget = document.querySelector(counter.dataset.characterCounterTarget);
        const maxLength = Number(counter.dataset.maxLength);
        if (maxLength) {
            // Since maxLength attribute doesn't work properly with emojis, we need to manually implement it's behavior
            counter.addEventListener('input', () => {
                const valueArray = [...Array.from(counter.value)].splice(0, maxLength);
                counter.value = valueArray.join('');
                counterDisplayTarget.textContent = `${maxLength - valueArray.length}`;
            });
        }
    });
}
